import { memo, useReducer, createContext } from 'react';
import { useTranslation } from 'react-i18next';
// @mui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Typography,
} from '@mui/material';

// components
import {
  SvgChevronRightFill, SvgWorldFill,
} from '../../SvgIcons';

//
import LanguageList from './LanguageList';

/* ======================================================================================== */

const LanguageContext = createContext({});

const initialValues = {
  open: false,
  visible: false,
  details: {},
  reply_details: {},
  readFlag: null
};

function reducer(state, action) {
  switch (action.type) {
    case 'OPEN_LIST_DRAWER':
      return action.data;
    case 'OPEN_DETAILS_DRAWER':
      return action.data;
    default:
      return initialValues;
  }
};

/* ======================================================================================== */


const LanguagePopup = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [state, commit] = useReducer(reducer, { initialValues });

  const toggleListDrawer = (visible) => (event) => {
    commit({
      type: 'OPEN_LIST_DRAWER',
      data: { open: visible }
    });
  };

  return (
    <LanguageContext.Provider value={{ state, commit }}>
      <Box
        onClick={toggleListDrawer(true)}
        display={'flex'}
        alignItems={'center'}
        borderTop={theme => `1px solid ${theme.palette.color.secondaryGreen1}`}
        mx={2.5}
        py={3}
        sx={{ cursor: 'pointer' }}
      >
        <SvgWorldFill color={'#A5D6FF'} />
        <Typography variant={'subtitle1'} fontWeight={700} color={'secondary.main'}>集團主頁 - 繁體中文</Typography>
        <Box flexGrow={1} />
        <SvgChevronRightFill color={'#A5D6FF'} />
      </Box>

      <LanguageList ct={LanguageContext} />
    </LanguageContext.Provider>
  );
};

export default memo(LanguagePopup);
